<div
  #rightMenu
  class="hidden lg:block filters-panel-container absolute top-0 right-0 w-full lg:w-64 h-screen max-h-screen overflow-y-auto transition-all duration-300 ease-in-out z-40"
  [class.translate-x-full]="!rightMenuExpanded()"
  (touchstart)="onDragStart($event)"
  (mousedown)="onDragStart($event)"
>
  <div class="h-full overflow-y-auto">
    <ng-content></ng-content>
  </div>
</div>
